// Follows basic rules for valid Canadian/US phone numbers
export function isPhoneNumber(phoneNumber: string) {
  if (!phoneNumber) {
    return false;
  }
  const withoutMasked = phoneNumber.replace(/\s/g, "");
  const validCanadianUsTenDigitNumberRegex = /^[2-9][0-9]{9}$/;
  const validCanadianUsElevenDigitNumberRegex = /^1[2-9][0-9]{9}$/;

  if (
    !withoutMasked
        || validCanadianUsTenDigitNumberRegex.test(withoutMasked)
        || validCanadianUsElevenDigitNumberRegex.test(withoutMasked)
  ) {
    return true;
  }

  return false;
}
